/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getProducts } from '../utils/api';
import { useLanguage } from '../store/languageContext';
import { FaWhatsapp } from "react-icons/fa";
import translate from '../utils/translation';
const ProductDetail = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [currentImage, setCurrentImage] = useState(0);
    const [loading, setLoading] = useState(true);
    const { language, setNavColor } = useLanguage();
    const sectionRef = useRef(null);
    useEffect(() => {
        getProducts({}).then((res) => {
            const foundProduct = res.data.find((p) => p.id == id);
            if (foundProduct) {
                const parsedProduct = {
                    ...foundProduct,
                    images: JSON.parse(foundProduct.images || '[]'),
                    specifications: JSON.parse(foundProduct.specifications || '{}'),
                };
                setProduct(parsedProduct);
            }
            setLoading(false);
        });
    }, [id]);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="loader border-4 border-gray-200 border-t-gray-500 rounded-full w-12 h-12 animate-spin"></div>
            </div>
        );
    }

    if (!product) {
        return <section ref={sectionRef} className='bg-[#222] h-screen pt-[150px]'>
            <div className='flex items-center justify-center text-3xl font-bold text-white'>Product not found.</div>;

        </section>
    }

    const { images, specifications: specs, title, description, price, brand_name, category, update_date } = product;
    const navigateWhatsApp = (productTitle) => {
        const currentTime = new Date();
        const hours = currentTime.getHours();
        const greeting = hours < 12 ? 'صباح الخير' : 'مساء الخير';
        const message = ` ${greeting}, أود الاستفسار عن المنتج: ${productTitle} 
        . يرجى التواصل معي.
        شكراً جزيلاً!`;
        const url = `https://wa.me/+201117169426?text=${encodeURIComponent(message)}`;
        return () => {
            window.open(url, '_blank');
        }
    }
    return (
        <section ref={sectionRef} className='bg-[#222] h-screen pt-[150px]'>
            <div className="flex gap-8 pt-[100px]mb-16 max-w-6xl mx-auto px-4">
                {/* Product Images - 60% width */}
                <div className="flex w-3/5 gap-8 flex-col-reverse">
                    {/* Small Images Thumbnails - Vertical */}
                    <ul className="flex items-center gap-4">
                        {images.map((img, i) => (
                            <li key={i} className="w-24 h-24">
                                <img
                                    src={img}
                                    alt={`${title} thumbnail ${i + 1}`}
                                    className={`!h-full !w-full object-cover opacity-40 cursor-pointer border border-gray-600 transition-opacity`}
                                    style={{ opacity: currentImage === i ? '1' : '' }}
                                    onClick={() => setCurrentImage(i)}
                                />
                            </li>
                        ))}
                    </ul>
                    {/* Big Image */}
                    <div className="h-[500px] flex items-center justify-center">
                        <img
                            src={images[currentImage] || images[0]}
                            alt={title}
                            className="w-full h-full object-cover border border-gray-600"
                        />
                    </div>
                </div>

                {/* Product Details - 40% width */}
                <div className="border border-gray-600 p-4 pl-8 w-2/5 flex flex-col justify-between">
                    {/* Brand and Title */}
                    {brand_name && (
                        <p className="text-sm text-gray-500 mb-2 capitalize">{brand_name} - {category}</p>
                    )}
                    <h1 className="font-normal text-2xl mb-2 text-white">{title}</h1>

                    {/* Price Container */}
                    <div className="mb-2 text-lg flex justify-between items-center">
                        <span className="flex items-center">
                            <span className="text-red-500 mr-1">{price} {translate[language].egp}</span>
                            {/* No old price in data, so omit; can add if needed */}
                        </span>
                        {/* No discount in data, so omit; can add if needed */}
                    </div>

                    {/* Subtitle (e.g., Category or Update) */}
                    <p className="mb-2 text-gray-500 text-sm">
                        {translate[language].LastUpdated}: {new Date(update_date).toLocaleDateString()}
                    </p>

                    {/* Description */}
                    <p className="mb-4 break-words text-gray-400 leading-relaxed">{description}</p>

                    {/* Specifications Section */}
                    {Object.keys(specs).length > 0 && (
                        <>
                            <h5 className="text-xl font-light text-gray-400 mb-2">{translate[language].Specifications}</h5>
                            <ul className="text-sm space-y-1">
                                {Object.entries(specs).map(([key, value]) => (
                                    <li key={key} className="text-gray-200 capitalize b">
                                        <span className="font-medium">- {key.replace(/_/g, ' ')}:</span> <span className='opacity-70'>{String(value)}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                    <button className="text-center flex justify-center items-center py-4 px-8 transition-all text-lg border-none  mt-6 w-full cursor-pointer bg-green-400 hover:bg-green-500" onClick={navigateWhatsApp(title)}>
                        <FaWhatsapp className="inline-block mx-2" /> {translate[language]['contactUs']}
                    </button>
                </div>
            </div>
        </section>

    );
};

export default ProductDetail;